const getEnvironment = () => {
  if (typeof window === "undefined") return;

  return {
    isDev:
      process.env.REACT_APP_ENV === "development" ||
      process.env.NODE_ENV === "development",
    isLocal: window.location.href.includes("localhost"),
  };
};

export default getEnvironment;
